import { useState } from 'react'
import { createQueue, createTriviaQuestions } from 'actions'
import { Button, Dropdown, Modal } from 'components'

export const LaunchActivityModal = ({ addressId, hide, show }) => {
  const [state, setState] = useState({
    type: 'trivia',
    parent_type: 'address',
    parent_id: addressId
  })

  const start = () => {
    createQueue(state).then((res) => {
      if (state.type === 'trivia') {
        createTriviaQuestions(res.data.queue.id, 10)
      }
    })
    hide()
  }

  const setGame = ({ target: { value } }) => {
    setState({ ...state, type: value })
  }

  return (
    <Modal show={show} hideModal={hide}>
      <Dropdown
        data={[
          ['Dash', 'dash'],
          ['Trivia', 'trivia'],
          ['Karaoke', 'karaoke']
        ]}
        onChange={setGame}
      />
      <Button onPress={start}>launch</Button>
    </Modal>
  )
}
